 
import React, { useEffect, useState, useContext } from "react";
import {MyContext} from "../components/Context";
import axios from "axios";

function FetchData() {
    const {data,setdata,jewelery, setjewelery,electronics, setelectronics,loading,isLoading}=useContext(MyContext)
    // const [category, setcategory] = useState([]);
  
  
    // const [men, setmen] = useState([]);
     
    const URL = `https://fakestoreapi.com/products `;
  
    
    useEffect(() => {
      const fetchData = async () => {
        try {
          const res = await axios.get(URL);
          isLoading(true);
  
          const categories = await axios.get(
            "https://fakestoreapi.com/products/categories"
          );
          const jewelerys = await axios.get(
            "https://fakestoreapi.com/products/category/jewelery"
          );
          const electronicsData = await axios.get(
            "https://fakestoreapi.com/products/category/electronics"
          );
          const mensWears = await axios.get(
            "https://fakestoreapi.com/products/category/men's-clothing"
          );
           
  
          setdata(res.data);
          isLoading(false);
          // setcategory(categories.data);
          setjewelery(jewelerys.data);
          setelectronics(electronicsData.data);
          // setmen(mensWears.data);
           
        } catch (err) {
          console.log(err);
        }
      };
  
      fetchData();
    }, []);
}

export default FetchData